import { toCurrencyString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';

interface EmspBoChargingSessionListTotalTtcCellProps
  extends CellContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['totalTTC']
  > {}

export const EmspBoChargingSessionListTotalTtcCell = ({
  getValue,
}: EmspBoChargingSessionListTotalTtcCellProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const value = getValue();

  // RENDER ////////////////////////////////////////////////////////////////////

  if (value === undefined || value === null) {
    return <span>—</span>;
  }

  return <span>{toCurrencyString(value)}</span>;
};
